export default "__VITE_ASSET__48f0741d__"